import * as types from "./actionTypes";
import * as scuolaApi from "../../api/scuolaApi";

import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadSchoolDataSuccess(clubData) {
  return {
    type: types.LOAD_SCUOLA_DATA_SUCCESS,
    clubData,
  };
}

export function clearDatiScuola() {
  return {
    type: types.SCUOLA_CLEAR,
  };
}

let lastSchoolReq = 0;

export function loadSchoolData(codScuola, lang) {
  return function (dispatch) {
    const req = ++lastSchoolReq;
    dispatch(beginApiCall());
    return scuolaApi
      .getDatiScuola(codScuola, lang)
      .then((c) => {
        if (req !== lastSchoolReq) {
          // Stale response: don't apply it. apiStatusReducer decrements
          // apiCallsInProgress on any "*_SUCCESS" action, so this keeps the
          // counter balanced. No reducer reacts to it.
          dispatch({ type: types.LOAD_SCUOLA_DATA_STALE_SUCCESS });
          return;
        }
        dispatch(loadSchoolDataSuccess(c));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

// export function loadNazioniSuccess(nazioni) {
//   return {
//     type: types.LOAD_NAZIONI_SUCCESS,
//     nazioni,
//   };
// }

// export function loadNazioni(codScuola) {
//   return function (dispatch) {
//     dispatch(beginApiCall());
//     return scuolaApi
//       .getNazioni(codScuola)
//       .then((c) => {
//         dispatch(loadNazioniSuccess(c));
//       })
//       .catch((error) => {
//         dispatch(apiCallError(error));
//         throw error;
//       });
//   };
// }
